import { GET_ACHIEVEMENTS_BY_STUDENTID } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ACHIEVEMENTS_BY_STUDENTID:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getAchivementsByStudentId.js